// extracted by mini-css-extract-plugin
export default {"section":"DashboardSection_section__O8b1N"};